import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { getClaimZdbList } from '@zurich/api/claim';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
import { claimListResultAtom, claimListResultPageinationAtom, } from '../recoil/atoms/claim';
export function usePostClaimList(policyNo) {
    const { t } = useTranslation();
    const setClaimListResult = useSetRecoilState(claimListResultAtom);
    const setClaimListResultPagination = useSetRecoilState(claimListResultPageinationAtom);
    const result = useApiQuery({
        request: getClaimZdbList,
        params: { vars: { policyNo } },
        options: { errorText: t('claim.list.error') },
        queryKey: [`claimlist-${policyNo}`, policyNo],
        queryOptions: {
            enabled: !!policyNo,
        },
    });
    useEffect(() => {
        if (result.dataState === 'success' && result.data) {
            const { data, ...paginationInfo } = result.data;
            setClaimListResult(data);
            // TODO: Implement pagination
            setClaimListResultPagination(paginationInfo);
        }
    }, [
        result.data,
        result.dataState,
        setClaimListResult,
        setClaimListResultPagination,
    ]);
    return result.dataState;
}
